/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- MONETIZATION - REVENUE PAGES : STYLES --------------- ++++++++++ */
export default {
    revenue: {
    },
    dimensionLabel: {
        marginBottom: pxToEm(10),
    },
    dimensionDropdown: {
        width: 'auto',
        '& .data, .chartsection, .group': {
            height: 'auto !important',
            alignItems: 'flex-start !important',
            flexDirection: 'column',
            width: '100%'
        },
        '& .dropDownItem': {
            width: '100%',
        }
    },
    legendsList: {
        '& .chartlegend': {
            marginRight: 0,
            paddingRight: 0,
            '& .title': {
                maxWidth: pxToEm(214),
                paddingRight: '0 !important',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }
        }
    },
    dimensionPagination: {
        fontSize: pxToEm(14),
        marginBottom: pxToEm(10),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '& span': {
            '&:first-child': {
                cursor: 'pointer',
                textDecoration: 'underline',
                '&:hover': {
                    '& .content': {
                        '& .value, .label': {
                            color: 'rgba(6, 43, 117, 0.7)'
                        }
                    },
                    filter: 'brightness(97%)'
                }
            }
        }
    },
};
